(function() {

  const wrapper =  document.querySelector('[data-section-type="product"]');

  init();

  function init() {
    document.addEventListener('theme:variant:change', function(event) {
      var variant = event.detail.variant;
      if (variant) {
        renderVariantsMedia(variant.id);
      }
    });
  }

  function renderVariantsMedia(id) {
    const media = wrapper.querySelector('[data-variants-media]');
    if (!id || !media) return;

    window
      .fetch(`${window.theme.routes.root_url}variants/${id}/?section_id=api-variants-media`)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        // handle success
        const fresh = document.createElement('div');
        fresh.innerHTML = response;
        media.innerHTML = fresh.querySelector('[data-api-content]').innerHTML;
        
        // configure slides
        document.dispatchEvent(new CustomEvent('theme:slideshow:init'));
      })
      .catch(function (error) {
        console.warn(error);
      });
  }

})();